import RollingConversation from "@js/guide/rollingConversation";
import { getData } from "@js/repository";
import { CONTI_URL, ALIAS, getContiApi } from "@js/config/conti";

class Guide {
  constructor(options) {
    const defaultOptions = {
      apiDomain: null,
      isLive: true, // live 서버인지 여부 (live / classic)
      isElyos: true, //
    };

    this.options = Object.assign({}, defaultOptions, options);
    this.init();
  }

  static get activeClassName() {
    return "current";
  }

  init() {
    const { isLive, isElyos } = this.options || {};
    const aliasKeyName = `GUIDE_${isLive ? "LIVE" : "CLASSIC"}_${
      isElyos ? "ELYOS" : "ASMODIAN"
    }`;
    const apiUrl = getContiApi(
      CONTI_URL.GROUP,
      this.options.apiDomain,
      ALIAS[aliasKeyName]
    );

    if (!apiUrl) {
      return;
    }

    getData({
      url: apiUrl,
    }).then((data) => {
      if (!Array.isArray(data) && data.length === 0) {
        return;
      }

      const jsonDataArr = data.map((v) =>
        v.jsonData ? JSON.parse(v.jsonData) : null
      );
      const filterData = this.setData(jsonDataArr);

      this.setGuideTab(filterData);
      this.setGuideTabContent(filterData);

      this.guideTabActive(); // 첫번째 탭 활성화
      this.setTabEvent();
      this.setSlick();

      this.roller = new RollingConversation();
      this.roller.init();
    });
  }

  setData(data) {
    return data.filter((v) => v.levelId && v.levelName && v.levelNumber);
  }

  setGuideTab(data) {
    const tabListEle = document.querySelector("#guideList");
    let tmpl = "";

    data.forEach((v) => {
      const { levelId, levelNumber, levelName } = v || {};
      tmpl += `<li class="list_item" data-tab="lv-${levelId || ""}">Lv<br>${
        levelNumber || ""
      }
                <span class="level_text">${levelName || ""}</span>
            </li>`;
    });

    if (tabListEle) {
      tabListEle.innerHTML = tmpl;
    }
  }

  setGuideTabContent(data) {
    const parent = document.querySelector(".guide_contents_wrap");
    let tmpl = "";

    data.forEach((v) => {
      const {
        levelId,
        levelNumber,
        levelName,
        conversation,
        guideTitle,
        guideDetail,
        buttonLink,
      } = v;

      tmpl += `<section id="lv-${
        levelId || ""
      }" class="wrap_content" data-levelnumber="${levelNumber}" data-levelname="${levelName}">
                    <ul class="conversation"> 
                        ${
                          Array.isArray(conversation) && conversation.length > 0
                            ? conversation
                                .map(
                                  (conv) => `<li>
                                ${
                                  conv.img.src
                                    ? `<img src="${conv.img.src}" class="character">`
                                    : ""
                                }
                                <div class="text_area">
                                    <div class="text_area_inner">
                                    <div class="teller">${
                                      conv.teller || ""
                                    }</div>
                                    <div class="sentence_area">
                                        <p class="sentence"><span class="sentence_inner">${
                                          conv.title
                                        }</span></p>
                                    </div>
                                    </div>
                                </div>
                                </li>`
                                )
                                .join("")
                            : ""
                        }
                    </ul>
                    <div class="story">
                    <h2 class="subtitle">${guideTitle}</h2>
                    <ul id="story-slick" class="story_list">
                        ${
                          Array.isArray(guideDetail) && guideDetail.length > 0
                            ? guideDetail
                                .map(
                                  (detail) => `<li class="list_item">
                            <div class="thumb">${
                              detail.img.src
                                ? `<img src="${detail.img.src}" width="100%" height="100%"></div>`
                                : ""
                            }
                            <div class="text">${detail.title}</div>
                            </li>`
                                )
                                .join("")
                            : ""
                        }
                    </ul>
                    <a href="${buttonLink}" class="btn_more">자세히 보러 가기</a>
                </div>
            </section>`;
    });

    if (parent) {
      parent.innerHTML = tmpl;
    }
  }

  setTabEvent() {
    const guideListItemEle = document.querySelectorAll("#guideList li");
    guideListItemEle.forEach((item) => {
      item.addEventListener("click", (e) => {
        const target = e.currentTarget;

        this.guideTabActive(target);

        if (this.roller) {
          this.roller.destroy();
          this.roller.updateTarget();
          this.roller.go(0);
        }

        $(".wrap_content.current .story_list").slick("resize");
      });
    });
  }

  guideTabActive(currentTabEle) {
    const activeClass = Guide.activeClassName;
    const guideListEle = document.querySelector("#guideList");
    const prevTab = guideListEle.querySelector(`li.${activeClass}`);
    const prevTabContent = document.querySelector(
      `.wrap_content.${activeClass}`
    );
    let tabEle = null;
    let tabContentEle = null;
    let tabId = null;

    prevTab && prevTab.classList.remove(activeClass);
    prevTabContent && prevTabContent.classList.remove(activeClass);

    if (!currentTabEle) {
      tabEle = guideListEle.querySelector("li:first-child");
      tabId = tabEle.dataset.tab;
      tabContentEle = document.querySelector(`#${tabId}`);
    } else {
      tabEle = currentTabEle;
      tabId = tabEle.dataset.tab;
      tabContentEle = document.querySelector(`#${tabId}`);
    }

    if (tabEle) {
      tabId = tabEle.dataset.tab;
      tabEle.classList.add(activeClass);
    }
    tabContentEle && tabContentEle.classList.add(activeClass);
  }

  setSlick() {
    const target = $(".wrap_content .story_list");
    $(target).each(function (index, item) {
      $(item).slick({
        dots: true,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 3000,
            settings: "unslick",
          },
          {
            breakpoint: 960,
            slidesToShow: 1,
          },
        ],
      });
    });

    $(window).resize(function () {
      $(`.wrap_content.${Guide.activeClassName} .story_list`).slick("resize");
    });
  }
}

export default Guide;
